/*
 * @Author: Ryan
 * @Date: 2026-01-16
 * @Description: 隐藏的 SEO 组件 - 输出 HeroVideoPlayer 的内容供爬虫抓取，视觉隐藏
 * 注意：此组件使用原生 img 标签而非 next/image，以确保爬虫能抓取到原始图片 URL
 */
import React from 'react';

import { HERO_VIDEOS, LANGUAGE_CONFIG } from '@/components/HeroVideoPlayer/videoData';

const VideoTranslatorHiddenSEO: React.FC = () => {
  return (
    // 使用 sr-only 隐藏，但保留在 DOM 中供爬虫抓取
    <div className="sr-only" aria-hidden="true">
      <h2>AI Video Translation Examples</h2>
      <p>
        FalcoCut AI Video Translator supports translation into multiple languages
        including{' '}
        {Object.values(LANGUAGE_CONFIG)
          .map((lang) => lang.name)
          .join(', ')}
        .
      </p>
      {HERO_VIDEOS.map((video) => (
        <article key={video.code}>
          <h3>
            Video Translation to {video.name} ({video.displayName})
          </h3>
          <p>
            Translate your videos into {video.name} with AI-powered voice cloning and lip
            sync.
          </p>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={video.posterUrl}
            alt={`${video.name} video translation`}
            width={640}
            height={360}
          />
          <video poster={video.posterUrl} preload="none">
            <source src={video.videoUrl} type="video/mp4" />
          </video>
        </article>
      ))}
    </div>
  );
};

export default VideoTranslatorHiddenSEO;
